import { functions } from "../../../firebase";
import { httpsCallable } from "firebase/functions";
// import { functions } from "../../firebase";
const storeDataToMail = async (
  email,
  businessEmail,
  businessName,
  propertySubType,
  propertyStatus,
  html
) => {
  try {
    const message = {
      to: email,
      from: businessEmail,
      message:
        "You receive this email from " +
        businessEmail +
        ", if you have further queries so contact us at: " +
        businessEmail,
      html: html,
      title: `${propertySubType} is on ${propertyStatus} | ${businessName}`,
    };
  
    const sendMail = httpsCallable(functions, "sendMail");
    await sendMail(message);
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default storeDataToMail;
